import {Spinner, view, css} from '@sail/ui/deprecated';
import {SizeScale} from '@stripe-internal/sail/types';

export function SpinnerRow({
  size,
  invisible = false,
}: {
  size?: SizeScale;
  invisible?: boolean;
}) {
  return (
    <view.div
      data-testid="SpinnerRow"
      css={{
        display: css.value('flex'),
        justifyContent: css.value('center'),
        marginY: 'medium',
        width: css.value('100%'),
        opacity: css.value(invisible ? 0 : 1),
      }}
    >
      <Spinner size={size} />
    </view.div>
  );
}
